// "props" should be the property name which should be omitted from the original object, for example: omitFromObject(object, "age", "name");
export const omitFromObject = (obj: any, ...props: any) => {
  const result = { ...obj };
  props.forEach(function (prop: any) {
    delete result[prop];
  });
  return result;
};
